import script from "./AppRouterLink.vue?vue&type=script&setup=true&lang=js"
export * from "./AppRouterLink.vue?vue&type=script&setup=true&lang=js"

import "./AppRouterLink.vue?vue&type=style&index=0&id=1b3d2eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b3d2eee"]])

export default __exports__